import { useAskStanley } from '@/features/ask-stanley';
import { useStanRouter } from '@/hooks/useStanRouter';

interface UseMobileModalNavigationProps {
    onClose: () => void;
}

/**
 * Hook to handle navigation from the mobile more modal.
 * Ensures the Ask Stanley chat is closed when navigating to other pages.
 */
export const useMobileModalNavigation = ({ onClose }: UseMobileModalNavigationProps) => {
    const { closeChat } = useAskStanley();
    const { push } = useStanRouter();

    const handleNavigation = (redirect?: boolean, route?: string) => {
        // Close the chat if open when navigating to other pages
        closeChat();

        // Close the modal first to trigger animation
        onClose();

        // Modal animation duration is 300ms, so we wait slightly longer
        if (route) {
            setTimeout(() => {
                if (redirect) {
                    window.open(route, '_blank');
                } else {
                    push(route);
                }
            }, 350);
        }
    };

    return { handleNavigation };
};
